import { ActionReducer } from '@ngrx/store';

import * as refunds from '../reducers/refunds.reducer';
import { RefundsState } from '../../interfaces/store.interface';

export const reducer: ActionReducer<RefundsState> = refunds.reducer;
